export const ExternalDimensioningTechnicalDataTableTypename =
  "ExternalDimensioningTechnicalDataTable" as const
export const ExternalDimensioningTechnicalDataDllVersionTypename =
  "ExternalDimensioningTechnicalDataDllVersion" as const
export const ExternalDimensioningResultTypename =
  "ExternalDimensioningResult" as const

export const VARIANT_KEY_MISMATCH_ERROR = "VARIANT_KEY_MISMATCH_ERROR" as const

export interface ExternalDimensioningConfigurationMismatchError {
  code: typeof VARIANT_KEY_MISMATCH_ERROR
  message?: string
  cause: {
    mismatches: {
      input: string
      cap: string
      mismatches: ExternalDimensioningConfigurationMismatch[]
    }[]
  }
}

export interface ExternalDimensioningConfigurationMismatch {
  input: string
  cap: string
  label?: string
  position?: number
}
